import { styled } from '@cad-arc';
import { FR_FOOTER_HEIGHT, FR_HEADER_HEIGHT } from '../../../fr-page-layout/constants';

export const TABS_HEADER_HEIGHT = 52;
export const TAB_CONTENT_PADDING = 24;
export const TOTAL_USED_PAGE_HEIGHT =
    FR_HEADER_HEIGHT + TABS_HEADER_HEIGHT + TAB_CONTENT_PADDING * 2 + FR_FOOTER_HEIGHT;
export const TOTAL_USED_PAGE_HEIGHT_WITHOUT_TAB_CONTENT_PADDING =
    TOTAL_USED_PAGE_HEIGHT - TAB_CONTENT_PADDING * 2;

export const FrTabContentWrapper = styled('div')<{ $noDefaultPadding?: boolean }>`
    display: flex;
    padding: ${({ $noDefaultPadding }) => ($noDefaultPadding ? 0 : `${TAB_CONTENT_PADDING}px`)};
    height: calc(100% - ${TABS_HEADER_HEIGHT}px);
    background-color: var(--arc-colors-surface-foreground);
`;
